module.exports = __webpack_public_path__ + "img/vue-crud-avatar.176f58ce.png";